/* eslint-disable @typescript-eslint/no-unused-vars */
import { useEffect, useMemo, useState } from 'react'
import CN from 'classnames'

import columnsStructure from './columnsStructure'
import Table from './Table'

import './DataTable.scss'

export const DataTable = ({
  itemData,
  className,
  tableVariables,
  setTableVariables,
  totalRowCount,
  setIsLoading,
  setPageNumber,
  pageNumber,
  setOpenEditShippingAddress,
  setRetryWmsOrderNo,
  handleRetryClick,
  integrationType,

  ...restProps
}) => {
  const [data, setData] = useState([])
  const [loading, setLoading] = useState(false)
  const columns = useMemo(() => columnsStructure, [])

  useEffect(() => {
    if (itemData?.length > 0) {
      setData([...itemData])
    }
  }, [itemData])

  return (
    <div className={CN('data-table w-full text-sm', className)} {...restProps}>
      <Table
        columns={columns}
        data={itemData}
        setTableVariables={setTableVariables}
        tableVariables={tableVariables}
        totalRowCount={totalRowCount}
        setIsLoading={setIsLoading}
        setPageNumber={setPageNumber}
        pageNumber={pageNumber}
        setOpenEditShippingAddress={setOpenEditShippingAddress}
        setRetryWmsOrderNo={setRetryWmsOrderNo}
        handleRetryClick={handleRetryClick}
        integrationType={integrationType}
      />
    </div>
  )
}

export default DataTable
